"use client";

import React, { useState } from "react";
import VerticalStepper from "./VerticalStepper";
import StepAgreement from "./StepAgreement";
import StepPersonalInfo from "./StepPersonalInfo";
import StepBranchSelection from "./StepBranchSelection";
import TrackRepairshopBookingForm from "./TrackRepairshopBookingForm";

export default function RepairshopReserveApp() {
  const [activeTab, setActiveTab] = useState("book"); // "book" | "track"
  const [currentStep, setCurrentStep] = useState(1);

  const [formData, setFormData] = useState({
    // Step 2: Personal
    firstName: "",
    lastName: "",
    mobile: "",
    nationalCode: "",
    vin: "",
    kilometer: "",
    platePart1: "",
    plateLetter: "",
    platePart2: "",
    plateCityCode: "",
    vehicleModelId: "",

    // Step 3: Selection
    provinceId: "",
    provinceName: "",
    cityId: "",
    cityName: "",
    dealerId: "",
    dealerName: "",
    branchId: "",
    branchName: "",
    serverGroupId: "",
    serverGroupName: "",
    workShopTimeTableId: "",
    bookingTime: "",
    repairAdviserId: "",
    description: "",
    address: ""
  });

  const STEPS = [
    { id: 1, title: "راهنمایی و شروع" },
    { id: 2, title: "اطلاعات فردی و خودرو" },
    { id: 3, title: "انتخاب نمایندگی و زمان" }
  ];

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const topElement = document.getElementById("stepper-top");
    if (topElement) {
      const y = topElement.getBoundingClientRect().top + window.scrollY - 20;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  const handleNext = () => {
    if (currentStep < 3) {
      setCurrentStep((prev) => prev + 1);
      scrollToTop();
    }
  };

  const handlePrev = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
      scrollToTop();
    }
  };

  const updateFormData = (newData) => {
    setFormData((prev) => ({ ...prev, ...newData }));
  };

  return (
    <main id="stepper-top" dir="rtl" className="max-w-6xl mx-auto px-4 py-8 md:py-12">
      {/* Header & Tabs */}
      <div className="py-4 border-b border-slate-100 mb-8 flex flex-col md:flex-row md:items-center justify-between gap-5 w-full">
        <div>
          <h1 className="text-2xl md:text-3xl font-black text-slate-800">
            سامانه نوبت دهی <span className="text-[#2b2b2b]">تعمیرگاه</span>
          </h1>
          <p className="text-sm text-slate-500 mt-2 font-medium">
            {activeTab === "book" ? "برای رزرو نوبت، مراحل زیر را با دقت تکمیل نمایید" : "پیگیری و یا لغو نوبت‌های ثبت شده"}
          </p>
        </div>

        <div className="flex w-full md:w-auto md:min-w-[350px] bg-slate-100 p-1.5 rounded-2xl border border-slate-200 shrink-0">
          <button
            onClick={() => setActiveTab("book")}
            className={`flex-1 py-3 sm:py-3.5 rounded-xl text-xs sm:text-sm font-bold transition-all ${activeTab === "book"
              ? "bg-[#2b2b2b] text-white shadow-md shadow-neutral-900/20"
              : "text-slate-600 hover:bg-slate-200"
              }`}
          >
            دریافت نوبت
          </button>
          <button
            onClick={() => setActiveTab("track")}
            className={`flex-1 py-3 sm:py-3.5 rounded-xl text-xs sm:text-sm font-bold transition-all ${activeTab === "track"
              ? "bg-[#2b2b2b] text-white shadow-md shadow-neutral-900/20"
              : "text-slate-600 hover:bg-slate-200"
              }`}
          >
            لغو و مشاهده نوبت
          </button>
        </div>
      </div>

      <div className={`transition-all duration-500 ${activeTab === "book" ? "opacity-100" : "hidden opacity-0"}`}>
        <div className="flex flex-col md:flex-row gap-6 md:gap-8 lg:gap-12">
          {/* Sidebar: Stepper */}
          <aside className="w-full md:w-1/3 lg:w-1/4 shrink-0">
            <div className="sticky top-8 bg-white p-6 md:p-8 rounded-3xl shadow-xl shadow-slate-200/50 border border-slate-100">
              <VerticalStepper steps={STEPS} currentStep={currentStep} />
            </div>
          </aside>

          {/* Main Content: Form Steps */}
          <section className="flex-1 bg-white p-6 md:p-8 lg:p-10 rounded-3xl shadow-xl shadow-slate-200/50 border border-slate-100 min-h-[500px] overflow-hidden">
            <div className="animate-in fade-in slide-in-from-right-8 duration-500 fill-mode-both relative h-full">
              <div className={currentStep === 1 ? "block h-full" : "hidden"}>
                <StepAgreement onNext={handleNext} />
              </div>

              <div className={currentStep === 2 ? "block h-full" : "hidden"}>
                <StepPersonalInfo
                  formData={formData}
                  updateFormData={updateFormData}
                  onNext={handleNext}
                  onPrev={handlePrev}
                />
              </div>

              <div className={currentStep === 3 ? "block h-full" : "hidden"}>
                <StepBranchSelection
                  formData={formData}
                  updateFormData={updateFormData}
                  onPrev={handlePrev}
                />
              </div>
            </div>
          </section>
        </div>
      </div>

      {activeTab === "track" && (
        <div className="animate-in fade-in slide-in-from-bottom-4 duration-500 max-w-3xl mx-auto w-full">
          <TrackRepairshopBookingForm />
        </div>
      )}
    </main>
  );
}
